import clsx from 'clsx';
import { statusColor, priorityColor } from '@/utils/format';

export function Badge({ children, className }) {
  return <span className={clsx('badge', className)}>{children}</span>;
}

export function StatusBadge({ status }) {
  const cls = statusColor[status] || 'bg-slate-200 text-slate-700';
  return <Badge className={cls}>{String(status || '').replace('-', ' ')}</Badge>;
}

export function PriorityBadge({ priority }) {
  const cls = priorityColor[priority] || 'bg-slate-100 text-slate-700';
  return <Badge className={cls}>{priority}</Badge>;
}
